import React from 'react'

import { useLocation } from 'react-router-dom'
import Highlight from '../../Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'

import ActivityOwner from '../ActivityOwner'

export default function DealStageChangedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props
  const location = useLocation()

  return (
    <>
      <ActivityTitle>
        <Highlight>Deal</Highlight> stage <Highlight>changed</Highlight>{' '}
        {showDocTypeDetails && <ActivityOwner activity={activity} />}
      </ActivityTitle>
      <QuoteActivitySubtitle
        activity={activity}
        showDocTypeDetails={showDocTypeDetails && !location.pathname.includes('/deals/')}
      />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
